module.exports = __webpack_public_path__ + "img/circle_trash_check.0d679587.png";